import React from 'react';
import styled from 'styled-components';
import { Container as BaseContainer, topBorder, PrimaryButton, SecondaryButton } from './GlobalStyle';
import { useI18n } from '../i18n';

const Section = styled.section`
  padding: 4rem 2rem;
  background: ${({ theme }) => theme.colors.bgSubtle};
  ${topBorder}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 3rem 1rem;
  }
`;

const Container = styled(BaseContainer)`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  align-items: center;
  gap: 1.5rem;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.brandDark};
  font-weight: 800;
  font-size: 1.5rem;
`;

const Sub = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  margin: 0.5rem 0 0;
  max-width: 560px;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const ExploreSection = () => {
  const { t } = useI18n();
  return (
    <Section>
      <Container>
        <div>
          <Title>{t('home.exploreTitle')}</Title>
          <Sub>{t('home.exploreSub')}</Sub>
        </div>
        <Actions>
          <PrimaryButton to="/solutions">{t('home.exploreCtaSolutions')}</PrimaryButton>
          <SecondaryButton to="/about">{t('home.exploreCtaAbout')}</SecondaryButton>
        </Actions>
      </Container>
    </Section>
  );
};

export default ExploreSection;
